import React from 'react';
import { Link } from 'react-router-dom';
import Button from '~/src/components/Button';
import { AiGemIcon } from '~/src/components/icons';
import { CUSTOM_TEMPLATES_STRING } from './constants';

interface FirmTemplatesSectionProps {}

const FirmTemplatesSection: React.FC<FirmTemplatesSectionProps> = () => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="text-lg font-semibold mb-4">{CUSTOM_TEMPLATES_STRING}</h3>
      <div className="flex flex-col items-center text-center">
        <AiGemIcon width={40} height={40} />
        <h3 className="text-lg font-semibold mb-4">
          Transform your documents into reusable templates - instantly
        </h3>
        <p className="text-600 text-sm mb-4">
          Upload a document, and let AI convert your files into customizable
          Word templates you can reuse across matters.
        </p>
        <Link to="/templates/setup">
          <Button primary small className="mb-6">
            Select documents
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FirmTemplatesSection;
